import { Helmet } from "react-helmet-async";

const STRUCTURA_SOFTWARE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Structura",
  description: "AI market structure intelligence",
  applicationCategory: "FinanceApplication",
  operatingSystem: "Web",
  featureList: [
    "Free: Accumulate, Divergence, Blocks",
    "Paid: Horizon, Pulse, Sentinel, Liquidity, Squeeze",
    "AI assistant: Prism",
  ],
  url: "https://structuramarkets.com",
  publisher: {
    "@type": "Organization",
    name: "Structura",
    url: "https://structuramarkets.com",
  },
};

export function StructuraSoftwareSchema() {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(STRUCTURA_SOFTWARE_SCHEMA)}
      </script>
    </Helmet>
  );
}

export { STRUCTURA_SOFTWARE_SCHEMA };

export default StructuraSoftwareSchema;

